import React from 'react';
import { formatCurrency } from '../../../utils/helpers';

const CompactServiceRows = ({ services, onServiceClick }) => (
  <div className="services-list" role="list">
    {services.map((service) => (
      <article key={service.id} className="service-list-row" role="listitem">
        <div className="service-list-main">
          <h3>{service.name}</h3>
        </div>

        <div className="service-list-side">
          <div className="service-list-meta">
            <span className="service-list-pill">{service.duration || 60} min</span>
            <span className="service-list-pill">{formatCurrency(service.price || 0)}</span>
          </div>

          <button
            type="button"
            className="service-list-action"
            onClick={() => onServiceClick(service)}
          >
            Book Service
          </button>
        </div>
      </article>
    ))}
  </div>
);

export default CompactServiceRows;
